"use strict";
/*
Copyright (C) 2009 - 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultOrderItemType = void 0;
/**
 * The default types of order items.
 */
var DefaultOrderItemType;
(function (DefaultOrderItemType) {
    /**
     * A normal order item with typical behavior.
     */
    DefaultOrderItemType["STANDARD"] = "STANDARD";
    /**
     * Represents a fee applied to the cart such as for Collect on Delivery or other payment
     * options. These are not to be included in the cart subtotal or quantity.
     */
    DefaultOrderItemType["EXTRA_FEE"] = "EXTRA_FEE";
    /**
     * Represents a fee applied to the cart for Collect on Delivery. These are not to be included
     * in the cart subtotal or quantity.
     */
    DefaultOrderItemType["COD_FEE"] = "COD_FEE";
})(DefaultOrderItemType = exports.DefaultOrderItemType || (exports.DefaultOrderItemType = {}));
//# sourceMappingURL=order.js.map